//-- Copyright (c) 2021 TMT Insights Group, LLC
import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { selectCurrentTableKey } from '@/redux/selectors/dataTableSelectors';
import { selectProcessingTasksIsLoading } from '@/redux/selectors/processingTasksSelectors';
import { setCurrentTable } from '@/redux/slices/dataTableSlice';
import LoadingBar from '@/components/_common/LoadingBar';
import TableContainer from '@/components/_common/Table/TableContainer';
import TransferQueueTitleBar from './TransferQueueTitleBar';
import DataTableFilters from '@/components/_common/Filters/DataTableFilters';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';

const TransferQueue = ({ onClose }: { onClose: () => void; }) => {
  const dispatch = useAppDispatch();
  const currentTableKey = useAppSelector(selectCurrentTableKey);
  const loading = useAppSelector(selectProcessingTasksIsLoading);

  useEffect(() => {
    dispatch(setCurrentTable('transferQueue'));
  }, []);

  return (
    <div>
      <LoadingBar loading={loading} />
      {currentTableKey === 'transferQueue' && (
        <>
          <TransferQueueTitleBar onClose={onClose} />
          <DataTableFilters disableExportReport />
          <StyledProcessingTable />
        </>
      )}
    </div>
  );
};

export default TransferQueue;

const StyledProcessingTable = styled(TableContainer)(
  ({ theme }) => `
  padding-bottom: ${theme.spacing(5)};
`
);
